// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-template-js": () => import("/tmp/3b43711/src/templates/blogTemplate.js" /* webpackChunkName: "component---src-templates-blog-template-js" */),
  "component---src-pages-index-js": () => import("/tmp/3b43711/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

